module.exports = __webpack_public_path__ + "img/H5_5.fd826fbf.png";